import React from 'react'

export default function Field(props) {
    return (
        <strong>
            {props.children && props.children !== 0 ? props.children : " - - - - - - -"}
        </strong>
    )
}
